import React from "react";

import { CompositeRate } from "../../constants/aquafina";
import { CoverageArrowRow, CoverageRow } from "../table/rows";
import { CoverageCell, CoverageHeaderCell } from "../table/cells";
import { RangeIterator } from "../../utils";

const labelOrder = [
  "Employee Only",
  "Employee + One Dependent",
  "Employee + Two Dependents",
  "Employee + Spouse",
  "Spouse Only",
  "Spouse + Children",
  "Spouse + Dependent",
  "Employee + Children",
  "Child Only",
  "Full Family",
];

const CompositeRates = ({ rates }: { rates: CompositeRate[] }) => {
  const tiers = new Map<string, string[]>();
  RangeIterator(rates.length, (index) => {
    (
      Object.keys(rates[index]?.tiers) as Array<keyof CompositeRate["tiers"]>
    ).forEach((keyTier) => {
      const rateLabel: string | undefined =
        rates[index]?.tiers?.[keyTier]?.label;
      if (!rateLabel) return;
      if (!tiers.has(rateLabel)) {
        tiers.set(rateLabel, new Array(rates.length).fill(""));
      }
      (tiers.get(rateLabel) as string[])[index] =
        rates[index]?.tiers?.[keyTier]?.rate;
    });
  });

  const sortedTiers = Array.from(tiers.entries()).sort(
    ([label1], [label2]) =>
      labelOrder.indexOf(label1) - labelOrder.indexOf(label2),
  );

  return (
    <>
      <CoverageRow label="Rates">
        {RangeIterator(rates.length, (index) => (
          <CoverageHeaderCell label={""} key={index} />
        ))}
      </CoverageRow>

      {sortedTiers.map(([label, values], indexTier) => (
        <CoverageArrowRow
          key={label}
          label={label}
          isWhite={indexTier % 2 === 0}
        >
          {values.map((value, index) => (
            <CoverageCell value={value} key={index} />
          ))}
        </CoverageArrowRow>
      ))}
    </>
  );
};

export default CompositeRates;
